module.exports = __webpack_public_path__ + "img/arrow-right-blue.e067ee7b.svg";